module.exports = __webpack_public_path__ + "static/img/yz4.45cbc454.png";